module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<table class="ui-table results-table doc-results">\n    <thead>\n        <tr>\n            <th class="hits" scope="col">Hits</th>\n            <th class="loc" scope="col">Location</th>\n            <th class="title" scope="col">Title / Text</th>\n        </tr>\n    </thead>\n    <tbody></tbody>\n</table>\n\n';
}
return __p;
};
